import { ConfirmModal } from '../../../shared/modal'

type ConfirmDeleteTemplateModalProps = {
  /** Determines visibility of modal */
  isOpen: boolean
  /** Label of template to delete */
  label: string
  /** Event callback when Confirm Button is triggered */
  onConfirm: () => void
}

const ConfirmDeleteTemplateModal = ({
  isOpen,
  label,
  onConfirm
}: ConfirmDeleteTemplateModalProps) => (
  <ConfirmModal
    confirmText={`Delete ${label}`}
    isOpen={isOpen}
    onConfirm={onConfirm}
    title={`Delete ${label}`}
  >
    Are you sure you want to delete this {label.toLowerCase()}? This cannot be undone.
    <p>
      Any user with access to this {label.toLowerCase()} will no longer see it in the{' '}
      {label.toLowerCase()} library.
    </p>
  </ConfirmModal>
)

export default ConfirmDeleteTemplateModal
